import React from 'react';
import { Check } from 'lucide-react';

interface PricingTableProps {
  plans?: any[];
  currentPlanId?: string;
  onPlanSelect?: (planId: string) => void;
  showCurrentPlan?: boolean;
  className?: string;
}

const ENTERPRISE_FEATURES = [
  'Custom-built AI audiences',
  'Tailored workflows across concepts, packaging, claims, and messaging',
  'Unlimited runs and scenarios',
  'Behavioral drivers behind every result',
  'Optional human + AI validation',
  'Executive-ready outputs',
];

const CALENDLY_URL = 'https://calendly.com/ad-blue-pill/30min';

const PricingTable: React.FC<PricingTableProps> = ({ className = '' }) => {
  return (
    <div className={`w-full ${className}`}>
      {/* Enterprise Card */}
      <div className="max-w-xl mx-auto">
        <div className="rounded-2xl border border-gray-200 bg-white shadow-sm p-8 md:p-10">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-3">
              Enterprise
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Built for insights, innovation, and brand teams making high-stakes decisions.
            </p>
          </div>

          <div className="space-y-4 mb-10">
            {ENTERPRISE_FEATURES.map((feature) => (
              <div key={feature} className="flex items-start gap-3">
                <Check className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-700">{feature}</span>
              </div>
            ))}
          </div>

          <button
            onClick={() => window.open(CALENDLY_URL, '_blank')}
            className="w-full py-3.5 px-4 rounded-lg font-semibold text-white bg-gray-900 hover:bg-gray-800 transition-colors"
          >
            Talk to us
          </button>
        </div>
      </div>

      {/* Supporting Copy */}
      <div className="mt-12 max-w-xl mx-auto text-center">
        <p className="text-gray-900 font-semibold mb-2">
          Not ready for an annual engagement?
        </p>
        <p className="text-gray-600 text-sm leading-relaxed mb-4">
          We offer a focused pilot to validate outputs from BluePill — designed to answer one real business question before scaling.
        </p>
        <button
          onClick={() => window.open(CALENDLY_URL, '_blank')}
          className="text-sm font-medium text-gray-900 underline underline-offset-4 hover:text-gray-700 transition-colors"
        >
          Talk to us to find the right setup →
        </button>
      </div>

      {/* Credibility Footer */}
      <p className="mt-16 text-center text-xs text-gray-400">
        Trusted by modern CPG teams replacing or augmenting traditional insights workflows.
      </p>
    </div>
  );
};

export default PricingTable;
